module.exports = __webpack_public_path__ + "img/rlogo-2.dd4d82ae.png";